import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboards-tables" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlannedEventsTable = _resolveComponent("PlannedEventsTable")!
  const _component_MinistryEventsTable = _resolveComponent("MinistryEventsTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PlannedEventsTable, {
      onChangeFilter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changePlannedEventsFilter', $event))),
      params: _ctx.params,
      hideSubjectFilter: _ctx.hideSubjectFilter,
      isDatesColumnFirst: _ctx.isDatesColumnFirst,
      hideCountryFilter: _ctx.hideCountryFilter
    }, null, 8, ["params", "hideSubjectFilter", "isDatesColumnFirst", "hideCountryFilter"]),
    (!_ctx.hideMinistryEvents)
      ? (_openBlock(), _createBlock(_component_MinistryEventsTable, {
          key: 0,
          params: _ctx.params,
          editable: _ctx.editable
        }, null, 8, ["params", "editable"]))
      : _createCommentVNode("", true)
  ]))
}